/* eslint-disable @blumintinc/blumint/extract-global-constants */
import { useMemo, useState } from 'react';
import Box from '@mui/material/Box';
import { ResultRanked } from './HeatLeaderboard';
import { ScoreOption } from 'functions/src/types/firestore/Game/Competition';
import { QualificationConditions } from 'functions/src/types/firestore/Game/Tournament';
import { GradientTypography } from '../../gradients/GradientTypography';
import { DataGrid } from '@mui/x-data-grid/DataGrid';
import { useLeaderboardEditing } from 'src/hooks/referee/useLeaderboardEditing';
import { useReferee } from 'src/contexts/RefereeContext';
import { useLeaderboardColumns } from 'src/hooks/leaderboards/useLeaderboardColumns';

export type HeatLeaderboardTableProps = {
  results?: ResultRanked[];
  qualification?: QualificationConditions;
  scoreOption?: ScoreOption;
  scoreOptions?: ScoreOption[];
};

export function HeatLeaderboardTable({
  results = [],
  qualification,
  scoreOption,
  scoreOptions,
}: HeatLeaderboardTableProps) {
  const { isRefereeView } = useReferee();
  const leaderboardPropsReferee = useLeaderboardEditing();

  const columns = useLeaderboardColumns({
    qualification,
    resultsLength: results.length,
    scoreOption,
    scoreOptions,
  });

  const [page, setPage] = useState(0);
  const pageSize = useMemo(() => {
    return results.length < 10 ? results.length : 10;
  }, [results.length]);
  const gridHeight = (isRefereeView ? 2 : 1) * (pageSize * 52 + 130);

  return (
    <Box>
      <GradientTypography
        gradientColor="primary.vertical"
        variant="h5"
        sx={{ mb: 1, ml: 3 }}
      >
        LEADERBOARD
      </GradientTypography>
      <Box sx={{ height: `${gridHeight}px` }}>
        <DataGrid
          rows={
            isRefereeView
              ? results.map((result) => {
                  return { ...result, editable: true, dynamicHeight: true };
                })
              : results
          }
          getRowId={(row) => {
            return `${row.userIdCaptain}-${row.id}`;
          }}
          columns={columns}
          pagination
          page={page}
          pageSize={pageSize}
          onPageChange={setPage}
          disableColumnFilter
          disableColumnMenu
          disableSelectionOnClick
          {...leaderboardPropsReferee}
        />
      </Box>
    </Box>
  );
}
